export default {
  text: 'Folosind acest site web, ești de acord cu',
  cookie_policy: 'Politica de cookie-uri.',
  buttons: {
    accept: 'Acceptă',
    reject: 'Respinge',
  },
};
